import { useState } from "react";
import { Link } from "react-router-dom";
import { MenuList } from "../MenuList";

const MenuItem = ({
    type = "",
    className = "",
    label = "",
    icon,
    href = "#",
    badge = "",
    isActive = false,
    onClick,
    onChangeActivetab,
    dropdown = false,
    dropdownList = [],
    activeTab,
}) => {
    const [showDropdown, setShowDropdown] = useState(false);

    const toggleDropdown = () => {
        setShowDropdown((prev) => !prev);
    };
    // console.log(badge);

    return (
        <li
            className={`${className} ${(!showDropdown && type != "dropdown" && isActive && !dropdown) || (showDropdown && (isActive || dropdown)) ? "side-menu__item--active" : ""}`}
        >
            <Link
                to={href}
                onClick={() => {
                    const tabName = type === "dropdown" ? href : label;
                    onChangeActivetab(tabName?.toLowerCase(), dropdown);
                    onClick && onClick();
                }}
            >
                <i className={icon}></i>
                <div className="side-menu__item-text">{label}</div>
                {!!badge && (
                    <div className="side-menu__notification">
                        <span>{badge}</span>
                    </div>
                )}
                {dropdown && (
                    <button className="side-menu__item-btn" onClick={toggleDropdown}>
                        <i className="fa-solid fa-chevron-down"></i>
                        <i className="fa-solid fa-dash"></i>
                    </button>
                )}
            </Link>
            {dropdown && dropdownList?.length > 0 && (
                <MenuList
                    className="side-menu__item-dropdown"
                    list={dropdownList}
                    type="dropdown"
                    showDropdown={showDropdown}
                    onMenuItemClick={onChangeActivetab}
                    activeTab={activeTab}
                />
            )}
        </li>
    );
};

export default MenuItem;
